import { defaultStore } from '../library/firebase'
export const getLandingImages = (speciality, city) => {
  console.log(speciality, city)
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('landing_images')
      .where('speciality', '==', speciality)
      .where('city', '==', city)
      // .where('image.direction', '==', 'width')
      .where('use', '==', true)
      .get()
      .then(doc => {
        const arr = []
        doc.forEach(doc => {
          arr.push(
            Object.assign({}, doc.data(), {
              text:
                '<b>Photographers101</b> is the platform that help you to find ' +
                'photographer_name whenever and wherever you want to take precious moment',
              title: 'Find photographer whenever and wherever'
            })
          )
        })
        resolve(arr)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}
